<template>
  <div>
    <HeaderPage>
      <div class="container mt-4">
        <h1>Liste des locations payées</h1>
        <div class="table-responsive">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Date Début</th>
                <th>Date Fin</th>
                <th>Quantité</th>
                <th>Articles</th>
                <th>Nom Client</th>
                <th>Téléphone</th>
                <th>Adresse</th>
                <th>Prix Total</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="location in locationsPayer" :key="location.id">
                <td>{{ location.date_debut }}</td>
                <td>{{ location.date_fin }}</td>
                <td>{{ location.quantite }}</td>
                <td>{{ location.nomArticles }}</td>
                <td>{{ location.NomClient }}</td>
                <td>{{ location.numero_telephone }}</td>
                <td>{{ location.adresse }}</td>
                <td>{{ location.prixTotal }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </HeaderPage>
  </div>
</template>

<script>
import axios from "axios";
import HeaderPage from './components/HeaderPage.vue';
const API_URL = process.env.VUE_APP_API_URL;

export default {
  name: "admin-page",
  components: {
    HeaderPage,
  },
  data() {
    return {
      locationsPayer: [], // Liste des locations payées
      chart: null,
    };
  },
  mounted() {
    this.fetchTableData();
  },
  methods: {
    // Récupérer les données de locations payées
    async fetchTableData() {
      try {
         const response = await axios.get(`${API_URL}/api/locations-payer`);
         this.locationsPayer = response.data;
      } catch (error) {
        console.error("Erreur lors de la récupération des locations payées :", error);
      }
    }
  }
};
</script>

<style scoped>
.table-responsive {
  overflow-x: auto;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table th,
.table td {
  padding: 12px;
  border: 1px solid #ddd;
}



.table tbody tr:hover {
  background-color: #f1f1f1;
}
</style>
